import type { GetReferencesHotelsImagesResponse } from '@lt/api/dist/methods/references/types';

export const getHotelImagesBySize = (
  response: GetReferencesHotelsImagesResponse,
) => {
  const hotel = response.hotels[0];
  if (!hotel) return null;

  const { id, images } = hotel;

  const size = 'x500';

  const hotelImages = {
    [id]: images.map((image) => ({
      jpg: image[size],
      webp: '',
    })),
  };

  return hotelImages;
};
